import React, { FC } from 'react';
import { LinkSource, ShortenLink } from 'types/LinkShortener';
import Link from 'components/shared/Link';
import { useTranslation } from 'react-i18next';
import OptionsBarFeatureItem from '../optionsBarFeatureItem/OptionsBarFeatureItem';

type Props = {
  shortenLink: ShortenLink;
  onDelete(linkId: string, source: LinkSource): void;
  onEdit(link: ShortenLink): void;
  onCopyToClipboard(link: string): void;
  onCopyToText?(link: string): void;
  onStatistics?(linkId: string, source: LinkSource): void;
  dataCy?: string;
};

const LinkShortenerItem: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <OptionsBarFeatureItem
      title={props.shortenLink.name || props.shortenLink.url}
      onDelete={() =>
        props.onDelete(props.shortenLink.id, props.shortenLink.source)
      }
      onEdit={() => props.onEdit(props.shortenLink)}
      onCopyToClipboard={() =>
        props.onCopyToClipboard(props.shortenLink.shortUrl)
      }
      onStatisticsClick={() =>
        props.onStatistics?.(props.shortenLink.id, props.shortenLink.source)
      }
      onCopyToText={
        props.onCopyToText
          ? () => props.onCopyToText?.(props.shortenLink.shortUrl)
          : undefined
      }
      dataCy={props.dataCy}
    >
      <div className="tw-flex tw-flex-col tw-gap-y-2">
        <div className="tw-text-sm">
          <span>{t('originalUrl')}:&nbsp;</span>
          <Link
            to={props.shortenLink.url}
            target="_blank"
            className="tw-break-words tw-font-medium tw-underline hover:tw-no-underline"
            data-cy={props.dataCy ? `${props.dataCy}-original-url` : null}
          >
            {props.shortenLink.url}
          </Link>
        </div>

        <div className="tw-text-sm">
          <span>{t('shortenedUrl')}:&nbsp;</span>
          <Link
            to={props.shortenLink.shortUrl}
            target="_blank"
            className="tw-break-words tw-font-medium tw-underline hover:tw-no-underline"
            data-cy={props.dataCy ? `${props.dataCy}-shortened-url` : null}
          >
            {props.shortenLink.shortUrl}
          </Link>
        </div>
      </div>
    </OptionsBarFeatureItem>
  );
};

export default LinkShortenerItem;
